import React, {useState, useEffect} from "react";
import * as prosConnect from "./ProsConnect";
import {getCopyMoveManager} from "./CopyMoveManager";
import ProsDate from "./ProsDate";
import {
    EditObsButton,
    renderNoCapacity,
    tagTexts,
    openPictureImportModal,
    TextContent, renderObsAttachments, stateIcons, renderItemByType,
    ItemMenuDropdown
} from "./ProsCommonUi";

import {
    ATTR_EXPIRATION, ATTR_IS_PICTURES_ALLOWED, ATTR_OBJ_ID, ATTR_OBJ_TYPE,
    getActiveProject,
    createNewObsComment,
    getItemsReport
} from "./ProsConnect";
import TextButton from "../components/TextButton";
import BasicButton from "../components/BasicButton";

export default function ProsObs({reportParent, obs, isOpen, ...props}){
    const [open, setOpen] = useState(isOpen || false)

    useEffect(()=> {
        setOpen(isOpen)
    },[isOpen])

    function renderObsContent(){
        if(!open){
            return null
        }
        return <div
                draggable={false}
                onClick={(evt) => {
                    evt.stopPropagation()//is needed (probably for drag&drop)
                }}
                className={"list-view-item-content"}
            >
            <ProsObsTop obs={obs} report={props.report} isReordering={props.isReordering} />
            {obs.obsObjList.length > 0 ? <div
                onClick={(evt) => {
                    evt.stopPropagation()
                }}
                className={obs.ui_isHistoryItem ? null : "grid-container grid-1" + (!props.isSidePanel ? " grid-2_lg"
                    + (props.isReordering ? "___ reorder-active" : "")
                        : "")}>
                {obs.obsObjList.map((itm, i) => {
                    return renderItemByType(itm, obs[prosConnect.ATTR_CREATED_BY], props.isReordering, reportParent)
                })}
            </div> : null}
            {!props.isReordering ? <ProsObsBottom obs={obs}/> : null}
        </div>
    }
    return <>
        <div
            className={"list-view-item-header"}>
            <h3 className={"obs-text"}>
                <TextContent text={prosConnect.getItemText(obs)}/>
                {renderObsAttachments(obs)}
                {props.isSidePanel ?
                    <span className={"title-thin"}>{prosConnect.getItemsReportName(obs[ATTR_OBJ_ID])}</span> : null}
            </h3>
            {stateIcons(obs)}
            {!props.isSidePanel && !props.isReordering ? <ItemMenuDropdown item={obs} toggleCallback={isOpen => {
                props.toggleSettingsDropdown(isOpen)
            }} /> : null}
        </div>
        {renderObsContent()}
    </>
}

function ProsObsTop({obs, ...props}){
    let project = prosConnect.getActiveProject()

    function renderEditObsButton(){
        return <EditObsButton
            obs={obs}
            report={getItemsReport(obs[ATTR_OBJ_ID])}
            shrink={"xl"}
        />
    }

    const saveExpiration = async (obs, timeMs) => {
        let attrChanges = {
            [ATTR_OBJ_ID]: obs[ATTR_OBJ_ID],
            [ATTR_OBJ_TYPE]: obs[ATTR_OBJ_TYPE],
            [ATTR_EXPIRATION]: timeMs
        }
        await project.awaitUpdateMultipleItemsAttributes([attrChanges])
    }

    function renderTagCollection(){
        if(!project){
            return null
        }
        return <>
            <ProsDate
                obs={obs}
                timeMs={prosConnect.getExpiration(obs)}
                isMissing={project.isExpirationDateMissing(obs)}
                timeTitle="Määräaika"
                useButtonTitle= {disabled ? undefined : "Tallenna"}
                onTimeChanged={timeMs => saveExpiration(obs, timeMs)}
                disabled={disabled}
            />
            {tagTexts(obs)}
        </>
    }

    const disabled = obs.ui_isHistoryItem || props.isReordering || getCopyMoveManager().isCopyOrMoveMode()
    return <div className={"element-set" + (disabled ? " disable-children" : "")}>
        <div className={"tag-collection"}>
            {renderTagCollection()}
        </div>
        {renderEditObsButton()}
    </div>
}

function ProsObsBottom({obs}){
    if(getCopyMoveManager().isCopyOrMoveMode()) return null
    return addTextOrAttachment(obs)
}

function addTextOrAttachment(item) {
    if (!prosConnect.hasPermissionTo("addContent", undefined, undefined)) {
        return null
    }
    if (!getActiveProject()) return null
    if (!getActiveProject().hasCapacityToAddItems(false)) {
        return renderNoCapacity('kommenttia');
    }
    // Do not show edit/add controls for history OBS items
    if (item.ui_isHistoryItem){
        return null
    }
    let isAddingPictureAllowed = prosConnect.getActiveProject().isAllowed(ATTR_IS_PICTURES_ALLOWED)
    let reasonPictureNotAllowed =  isAddingPictureAllowed ?
        undefined : ["Kuvien lisääminen projektiin on estetty", "tooltip-bottom"]
    return <div
            onClick={(evt) => {
                evt.stopPropagation()
            }}
            className={"padding-top element-set-sm"}
        >
        <TextButton
            btnClass={"primary"}
            icon={"comment-text"}
            disabled={item.ui_isHistoryItem}
            label={"kommentoi"}
            multiline={1}
            onSubmit={val=> {
                createNewObsComment(item[ATTR_OBJ_ID], val)
            }}
        />
        <BasicButton
            btnClass={"primary"}
            icon="pack"
            label={"Liitä"}
            action={() => {
                openPictureImportModal(item)
            }}
            disabled={item.ui_isHistoryItem ||!isAddingPictureAllowed}
            tooltip={reasonPictureNotAllowed}
        />
    </div>
}